import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  template: `
    <div [ngClass]="getCardClasses()">
      <div *ngIf="title" class="px-6 py-4">
        <h3 class="text-lg font-semibold text-neutral-900 dark:text-neutral-100">{{ title }}</h3>
      </div>
      <div [class]="getContentClasses()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: []
})
export class CardComponent {
  @Input() title?: string;
  @Input() padding: 'sm' | 'md' | 'lg' | 'none' = 'md';
  @Input() shadow: boolean = false;
  @Input() interactive: boolean = false;
  @Input() additionalClasses?: string; // Allow additional classes to be passed

  getCardClasses(): string | string[] {
    const classes: string[] = [
      'rounded-lg',
      'border',
      'overflow-hidden'
    ];
    
    // Add background and border - use additionalClasses if provided, otherwise default
    if (this.additionalClasses) {
      // Split additionalClasses and add all classes
      const additional = this.additionalClasses.split(' ').filter(c => c.trim());
      classes.push(...additional);
    } else {
      // Default classes when no additional classes provided - theme-aware
      classes.push('bg-background-secondary', 'border-neutral-200/70', 'dark:border-neutral-600/70');
    }
    
    if (this.shadow) {
      classes.push('shadow-sm');
    }
    
    if (this.interactive) {
      classes.push('cursor-pointer', 'hover:border-primary-400/50', 'transition-colors', 'duration-200');
    }
    
    return classes;
  }

  getContentClasses(): string {
    const classes = [];
    
    if (this.padding === 'sm') {
      classes.push('p-4');
    } else if (this.padding === 'lg') {
      classes.push('p-8');
    } else if (this.padding === 'none') {
      // No padding
    } else {
      classes.push('p-6');
    }
    
    return classes.join(' ');
  }
}
